import React from "react"
import { createPortal } from "react-dom"

import { getDocument } from "shared/lib/getDocument"
import { Button, ButtonProps, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export const ActionsButton = React.memo(({ icon, ...props }: ButtonProps) => {
  const rootElement = getDocument()?.getElementById("main")

  const element = (
    <Button
      variant={ButtonVariant.PRIMARY}
      {...props}
      data-testid={props["data-testid"] || "actions-button"}
      icon={icon || IconName.KEBAB}
      className="actions-button"
      isIconOnly
    />
  )

  if (!rootElement) {
    return null
  }
  return createPortal(element, rootElement)
})
